import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { MEDIUM, EXTRA_LARGE } from "../../../../constants/breakpoints/breakpoints.js";
import "react/jsx-runtime";
import "../../../../themes/typography/typography.js";
import "color-alpha";
import { ExternalTheme } from "../../../../themes/external-theme/external-theme.js";
import "../../../../themes/pickers-popper/pickers-popper.js";
import "../../../../themes/shadows/shadows.js";
import "../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../../constants/create-theme/create-theme.js";
import "../../../../constants/colors/palette.js";
import "../../../../themes/alert/alert.js";
import "../../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../../themes/button/button.js";
import "../../../../themes/button/styles/external/bordered.styles.js";
import "../../../../themes/button/styles/external/filled.styles.js";
import "../../../../themes/button/styles/internal/bordered.styles.js";
import "../../../../themes/button/styles/internal/borderless.styles.js";
import "../../../../themes/button/styles/internal/filled.styles.js";
import "../../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../../themes/checkbox/checkbox.js";
import "../../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../../themes/form-control-label/form-control-label.js";
import "../../../../themes/radio/radio.js";
import "../../../../themes/switch/switch.js";
const Container = styled(Box)(({ shouldHideOnDesktop }) => ({
  position: "fixed",
  bottom: "1.25rem",
  right: "1.5rem",
  [ExternalTheme.breakpoints.up(MEDIUM)]: {
    display: shouldHideOnDesktop ? "none" : "block"
  },
  [ExternalTheme.breakpoints.up(EXTRA_LARGE)]: {
    right: "calc(50% - 1000px)"
  }
}));
export {
  Container
};
